import { render } from "./team-members.vue?vue&type=template&id=3341ec9b"
import script from "./team-members.vue?vue&type=script&lang=js"
export * from "./team-members.vue?vue&type=script&lang=js"

import exportComponent from "/home/rowen/www/html/catholic-club-fleet-base/themes/default/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__